export const SET_PROJECT_REQUIREMENTS_ERROR = 'SET_PROJECT_REQUIREMENTS_ERROR';
export const SET_PROJECT_REQUIREMENTS_LIST = 'SET_PROJECT_REQUIREMENTS_LIST';
export const SET_TOTAL_AMOUNT_OF_PROJECT_REQUIREMENTS = 'SET_TOTAL_AMOUNT_OF_PROJECT_REQUIREMENTS';
export const SET_FETCHING_PROJECT_REQUIREMENTS = 'SET_FETCHING_PROJECT_REQUIREMENTS';
